import React, { Component } from "react";
import { GetData, PutData } from "../../api/service";
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Chip,
} from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";
import Star from "@material-ui/icons/Star";
import StarBorder from "@material-ui/icons/StarBorder";
import Snack from "../Snackbar/Snack";

export default class FeaturedNotificationLanding extends Component {
  state = {
    list: [],
    isLoaded: false,
    open: false,
    message: "",
  };

  componentDidMount() {
    this.__loadData();
  }

  __loadData = () => {
    GetData(`/${this.props.apikey}/get-featured-notifications`).then((resp) => {
      this.setState({
        list: resp,
        isLoaded: true,
      });
    });
  };

  __activate = (id) => {
    PutData(`/${this.props.apikey}/${id}/activate-featured-notification`, {})
      .then((resp) => {
        this.setState({
          open: true,
          message: resp,
        });
      })
      .then(() => {
        this.__loadData();
      });
  };

  render() {
    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            handleClose={() => {
              this.setState({
                open: false,
                message: "",
              });
            }}
            message={this.state.message}
          />
        ) : null}

        <Typography variant="h6">Featured Notification</Typography>

        <div align="right">
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              this.props.history.push("/featured-notification/add")
            }
          >
            Add Featured Notification
          </Button>
        </div>
        <br />
        <Table size="small" style={{ backgroundColor: "#fff" }}>
          <TableHead>
            <TableRow>
              <TableCell width="5%">#</TableCell>
              <TableCell width="10%">Date</TableCell>
              <TableCell width="35%">Title</TableCell>
              <TableCell width="15%">Time Stamp</TableCell>
              <TableCell width="15%">Status</TableCell>
              <TableCell width="10%">Activate</TableCell>
              <TableCell width="10%">Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.list.map((el, index) => (
              <TableRow key={index} style={{ verticalAlign: "top" }}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{el.date}</TableCell>
                <TableCell>{el.title}</TableCell>
                <TableCell>{el.time_stamp}</TableCell>
                <TableCell>
                  {parseInt(el.is_active) === 1 ? (
                    <Chip
                      icon={<Star />}
                      label="Active"
                      color="primary"
                    />
                  ) : (
                    <Chip
                      icon={<StarBorder />}
                      label="Inactive"
                    />
                  )}
                </TableCell>
                <TableCell>
                  {parseInt(el.is_active) === 1 ? null : (
                    <Button
                      size="small"
                      variant="outlined"
                      color="primary"
                      onClick={() => this.__activate(el.id)}
                    >
                      Set Active
                    </Button>
                  )}
                </TableCell>
                <TableCell>
                  <Edit
                    onClick={() =>
                      this.props.history.push(
                        "/featured-notification/edit",
                        el
                      )
                    }
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/FeaturedNotification/FeaturedNotificationLanding.js